module.exports = __webpack_public_path__ + "static/media/prelight.cf3757d6.png";